import { QualifiedId } from "@src/core/engine/products/types";
import { SuggestionDetails } from "@src/core/engine/technicalSelection/helpers/buildSuggestion";
import { ValidationResult } from "@src/core/engine/validationResults/buildValidationResult";
import { TechnicalSelectionOutput } from "@src/routes/projects/$projectId/selections/hooks/useBuildSuggestionOutput";

export const batchInputColumns: (keyof BatchInputs)[] = [
  "additionalReference",
  "differentialTemperature",
  "dp",
  "flow",
  "pipeSize",
  "power",
  "quantity",
  "reference",
];

export type BatchFormattedSuggestion = {
  description: Record<string, string | null | undefined>;
  output: Record<string, TechnicalSelectionOutput>;
} & Omit<SuggestionDetails, "description" | "output">;

export type BatchInputs = {
  additionalReference: string;
  differentialTemperature?: string;
  dp?: string;
  flow?: string;
  pipeSize?: string;
  power?: string;
  quantity: string;
  reference: string;
};

export type BatchSelectionRow = {
  id: string;
  inputErrors?: Record<string, ValidationResult>;
  output: Output;
  status?: ValidationResult | null;
} & BatchInputs;

export type SubProductsSelection = {
  disabledIds: QualifiedId[];
  selectedIds: QualifiedId[];
};

type Output = {
  correlationId?: string;
  pipeResult: Record<string, TechnicalSelectionOutput> | null;
  status: "idle" | "loaded" | "loading";
  subProductsSelection: SubProductsSelection | null;
  suggestion: BatchFormattedSuggestion | null;
};
